import { render } from "./Footbar.vue?vue&type=template&id=bf2fa298&scoped=true"
import script from "./Footbar.vue?vue&type=script&lang=js"
export * from "./Footbar.vue?vue&type=script&lang=js"

import "./Footbar.vue?vue&type=style&index=0&id=bf2fa298&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf2fa298"]])

export default __exports__